// material-ui
import {useTheme} from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// project-imports
import DrawerHeaderStyled from './DrawerHeaderStyled';

import {DRAWER_WIDTH, HEADER_HEIGHT, MenuOrientation} from 'configs/themeConfig';
import {useConfigurationInRedux} from 'hooks';
import {LogoSection} from 'components/Theme/logo/LogoSection';

interface Props {
    open: boolean;
}

// ==============================|| DRAWER HEADER ||============================== //

export const DrawerHeader: React.FC<Props> = ({open}) => {
    const theme = useTheme();
    const downLG = useMediaQuery(theme.breakpoints.down('lg'));

    const {menuOrientation} = useConfigurationInRedux();
    const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

    return (
        <DrawerHeaderStyled
            theme={theme}
            open={open}
            sx={{
                minHeight: isHorizontal ? 'unset' : HEADER_HEIGHT,
                width: isHorizontal ? {xs: '100%', lg: DRAWER_WIDTH + 50} : 'inherit',
                paddingTop: isHorizontal ? {xs: '10px', lg: '0'} : '8px',
                paddingBottom: isHorizontal ? {xs: '18px', lg: '0'} : '8px',
            }}
        >
            <LogoSection isIcon={!open} />
        </DrawerHeaderStyled>
    );
};

export default DrawerHeader;
